const couponTypeOptions = [
	{ value: 'pointsPurchase', label: 'Compra de pontos' },
	{ value: 'ticketPurchase', label: 'Compra de passagem' },
]

const couponBusCompanyOptions = [
	{ value: 'Unesul', label: 'Unesul' },
	{ value: 'Planalto', label: 'Planalto' },
	{ value: 'Rota', label: 'Rota 10' },
	{ value: 'Muvibus', label: 'Muvibus' },
	{ value: 'CATARINENSE', label: 'Catarinense' },
	{ value: 'MILUM', label: '1001' },
	{ value: 'EXPRESSODOSUL', label: 'Expresso do Sul' },
	{ value: 'COMETA', label: 'Cometa' },
	{ value: 'RAPIDORIBEIRAOPRETO', label: 'Rápido Ribeirão Preto' },
	{ value: 'TTL', label: 'TTL' },
	{ value: 'CITRAL', label: 'Citral' },
	{ value: 'Todos', label: 'Todos' }
]

const couponPaymentMethodOptions = [
	{ value: '0', label: 'Todos' },
	{ value: '1', label: 'Cartão' },
	{ value: '2', label: 'Muvicard' },
	{ value: '3', label: 'PIX' },
]

export const couponConstants = { couponTypeOptions, couponBusCompanyOptions, couponPaymentMethodOptions }
